import http from '@/utils/request'
import { getLocaleStorage, removeLocaleStorage, setLocaleStorage } from './storage'
import { USER_INFO, PLATFORM_INFO, DIGISIN_INFO } from './constant'
import { AccountBalanceResponse } from '@/views/register/register.interface'

// User info
export const getUserInfo = (prop?: string) => getLocaleStorage(USER_INFO, prop)
export const setUserInfo = (prop: any, value?: any) => setLocaleStorage(USER_INFO, prop, value)
export const removeUserInfo = () => removeLocaleStorage(USER_INFO)

// Platform info
export const getPlatformInfo = (prop?: string) => getLocaleStorage(PLATFORM_INFO, prop)
export const setPlatformInfo = (prop: any, value?: any) => setLocaleStorage(PLATFORM_INFO, prop, value)
export const removePlatformInfo = () => removeLocaleStorage(PLATFORM_INFO)

// Digisign info
export const getDigisiginInfo = (prop?: string) => getLocaleStorage(DIGISIN_INFO, prop)
export const setDigisignInfo = (prop: any, value?: any) => setLocaleStorage(DIGISIN_INFO, prop, value)
export const removeDigisigInfo = () => removeLocaleStorage(DIGISIN_INFO)

// Fetching digisign data
export const getDigisign = (): Promise<any> => {
  return new Promise(resolve => {
    const tenantId = getUserInfo('tenantId')
    const { userNo } = getUserInfo('userInfoMap')
    http
      .post('/sign/selectData', { tenantId, userNo })
      .then(data => {
        resolve(data)
      })
      .catch(() => {
        resolve(false)
      })
  })
}

// check digisign account
export const checkDigisign = (): Promise<boolean> => {
  return new Promise(resolve => {
    const params = { userNo: getUserInfo('userInfoMap').userNo, type: 6 }
    http
      .post('/sign/isActive', params)
      .then(data => {
        resolve(data)
      })
      .catch(() => {
        resolve(false)
      })
  })
}

export const checkAccountBalance = (): Promise<boolean> => {
  return new Promise(resolve => {
    http
      .post<AccountBalanceResponse>('/rdl/accountBalance')
      .then(data => {
        const { accountNumber } = data || {}
        if (accountNumber) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
      .catch(() => {
        resolve(false)
      })
  })
}

export const checkAccountInfo = (): Promise<boolean> => {
  return new Promise(resolve => {
    http
      .post('/user/accountInfo')
      .then(({ data }) => {
        if (data && data.code === '200') {
          const { status } = data.result
          if (~~status === 3) {
            resolve(true)
          } else {
            resolve(false)
          }
        } else {
          resolve(false)
        }
      })
      .catch(() => {
        resolve(false)
      })
  })
}

export const validateAccount = (): Promise<boolean> => {
  return new Promise(resolve => {
    http
      .post('/rdl/validateAccount')
      .then(({ data }) => {
        if (data && data.code === '200') {
          if (data.result.accountStatus) {
            resolve(true)
          } else {
            resolve(false)
          }
        } else {
          resolve(false)
        }
      })
      .catch(() => {
        resolve(false)
      })
  })
}

// export const checkRDL = async () => {}

// export const checkRegister = async () => {}
